module.exports = __webpack_public_path__ + "img/thumbnail_GrizzlyBear_f_albino.48fffa59.png";